import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { ImageDialogComponent } from 'src/app/components/shared-components/image-dialog/image-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { CompanyInfo } from 'src/app/models/company-data-model/company-info.model';
import { CompanyCompanyService } from 'src/app/services/company-services/company-company-service/company-company.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';

@Component({
  selector: 'app-company-s-photo-editor-card',
  templateUrl: './company-s-photo-editor-card.component.html',
  styleUrls: ['./company-s-photo-editor-card.component.scss']
})
export class CompanySPhotoEditorCardComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() companyInfo: CompanyInfo;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private validationImageService: ValidationImageService,
              private userStorageService: UserStorageService,
              private companyService: CompanyCompanyService,
              private snackbarService: SnackBarService,
              private spinnerService: SpinnerService,
              public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: this.width, height: this.height }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result) {
            this.companyInfo.ImageS = result;
            this.showSpinner = true;
            this.spinnerService.show('company-s-image-spinner');
            this.companyService.updateCompanyImage(this.companyInfo.InternalId, result, 'S').pipe(
              tap(o => this.companyService.refreshCompany()),
              tap(o => this.showSpinner = false),
              tap(o => this.spinnerService.hide('company-s-image-spinner')),
              tap(o => this.snackbarService.open('validation-images.snackbar messages.update image success', 'success')),
              catchError(error => {
                this.companyService.refreshCompany();
                this.showSpinner = false;
                this.spinnerService.hide('company-s-image-spinner');
                this.snackbarService.open(error['error']['message'], 'error');
                return EMPTY;
              })
            ).subscribe();
          }
        });
      },
      (error) => {
        this.companyService.refreshCompany();
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('company-s-image-spinner');
    this.companyService.updateCompanyImage(this.companyInfo.InternalId, null, 'S').pipe(
      tap(o => this.companyService.refreshCompany()),
      tap(o => this.showSpinner = false),
      tap(o => this.spinnerService.hide('company-s-image-spinner')),
      tap(o => this.snackbarService.open('validation-images.snackbar messages.update image success', 'success')),
      catchError(error => {
        this.companyService.refreshCompany();
        this.showSpinner = false;
        this.spinnerService.hide('company-s-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.companyInfo.ImageS, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

}
